import { render, staticRenderFns } from "./BindersUpdate.vue?vue&type=template&id=dac96264"
import script from "./BindersUpdate.vue?vue&type=script&lang=js"
export * from "./BindersUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports